export default __webpack_public_path__ + "static/media/spindex-banner-inner.d5bf7b4f.jpg";